import { API } from "./api";

/**
 * Resolve a media URL coming from the backend.
 * - Empty / null → returns "".
 * - Full http(s) URLs → returned as-is.
 * - Relative `/api/media/...` paths → prefixed with the resolved API base
 *   (or kept as relative when on the production custom domain via ingress).
 */
export function resolveMediaUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  if (typeof url === "string" && url.startsWith("/api/")) {
    // API is e.g. "https://host/api" or "/api". Strip the trailing /api once.
    const base = API.replace(/\/api$/, "");
    return base + url;
  }
  return url;
}
